export interface USPsProps {
  /** Title */
  title: string;
  /** USPs */
  items: string[];
  /** Additional class */
  className?: string;
}

/** List of usps */
export const USPs = ({ title, items, className, ...props }: USPsProps) => {
  return (
    <div className={['usps', className].join(' ')} {...props}>
      {title && <h4 className="usps__title">{title}</h4>}
      <ul className="usps__items">
        {items.map((item, i) => {
          return (
            <li key={i} className="usps__item">
              {item}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
